import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { pdpStore } from '@/scopes/products/infrastructure/store';
import { PDPDependenciesProvider } from '@/scopes/products/infrastructure/dependencies';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,
    },
  },
});

function AccomodationPage({ children }: PropsWithChildren) {
  const { sendEvent } = useAnalytics();

  //This event is for the A/B test of full react PDP -- to be removed once the test is over
  useEffect(() => {
    sendEvent({
      event: 'CRO',
      description: 'ID 368 | PDP react',
      element: 'NL',
      type: 'A/B test',
      result: 'Default',
      interaction: false,
    });
  }, []);

  return (
    <PDPDependenciesProvider dependencies={{ pdpStore }}>
      <QueryClientProvider client={queryClient}>
        {children}
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools client={queryClient} />}
      </QueryClientProvider>
    </PDPDependenciesProvider>
  );
}

export default AccomodationPage;
